import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { List, message, Select, Spin, Tag } from 'antd';
import AddTagsModal from '../AddTagsModal/AddTagsModal';
import RenderListItem from './components/RenderListItem';
import { AuditMarkingContext } from '../../../context';
import {
	auditMarkingGetTagsList,
	aditMarkingTaggingRecommendTaggs,
	aditMarkingTaggingGetAddedTaggs,
} from '../../../../../../api/inspiration'
import * as actiontypes from '../../../reducer/action';
import debounce from 'lodash/debounce';
import { v4 as uuidv4 } from 'uuid';
import './TagListManager.less';

function TagListManager(props) {
	const { state, dispatch } = useContext(AuditMarkingContext);
	const debanceFetch = useRef(debounce((v) => getTagsList(v), 500)).current;
	const [selectValue, setSelectValue] = useState([]);
	const changeTagsSelect = (value) => {
		if (state.insGroup.filter((v) => v.checked).length === 0) {
			return message.info('请选择一个图片后，再进行打标签！');
		}
		dispatch({
			type: actiontypes.setData,
			data: {
				tagsFetchLoading: true,
			},
		});
		value && debanceFetch(value);
	};
	useEffect(() => {
		let element = null;
		function clearSelect() {
			setSelectValue([]);
		}
		if (selectValue.length !== 0) {
			element = document.querySelector(".ant-select-selection__clear");
			if (element) {
				element.addEventListener('click', clearSelect);
			}
		}
		return () => {
			if (element) {
				element.removeEventListener('click', clearSelect);
			}
		}
	}, [selectValue]);
	// 获取所有的标签
	const getTagsList = async (value) => {
		const result = await auditMarkingGetTagsList(value);
		if (result?.error?.code === 0) {
			dispatch({
				type: actiontypes.setData,
				data: {
					tagsFetchLoading: false,
					tagList: result?.data ?? [],
				},
			});
		}
	};
	// 点击标签下拉框时的方法
	const selectTagsSelectOption = (v, t) => {
		const array = v.split('-');
		const type = Number(array[0]);
		const id = Number(array[1]);
		const word = array[2];
		const style = array[3];
		const entity = array[4];
		const parentId = array[5];
		state.insGroup.forEach((v) => {
			if (v.checked) {
				if (v?.newTags?.map) {
					// 如果有 newTags 并且是数组
					const index = v.newTags.findIndex((t) => t.id === id && t.parentId === parentId);
					if (index === -1) {
						v.newTags.push({
							id,
							type,
							word,
							style,
							entity,
							parentId
						});
						dispatch({
							type: actiontypes.setTagsCache,
							newTag: {
								id,
								type,
								word,
								style,
								entity,
								parentId
							},
						});
					}
				} else {
					v.newTags = [
						{
							id,
							type,
							word,
							style,
							entity,
							parentId
						},
					];
					dispatch({
						type: actiontypes.setTagsCache,
						newTag: {
							id,
							type,
							word,
							style,
							entity,
							parentId
						},
					});
				}
			}
		});
		dispatch({
			type: actiontypes.setData,
			data: {
				insGroup: [...state.insGroup],
			},
		});
		if (t) {
			selectValue.push(v);
			setSelectValue([...selectValue]);
		}
	};
	const clearFunction = () => {
		setSelectValue([]);
	}
	// 渲染标签名称
	const renderSelectTags = (item) => {
		if (item.type === 1) {
			return `${item.word}【${item.entity}】`;
		} else if (item.type === 2) {
			return `${item.word}【自定义】`;
		} else {
			return `${item.word}${item.style ? `【${item.style}】` : ''}`;
		}
	};
	// 渲染实体
	const renderEntitySelectTags = (item) => {
		if (item.type === 1) {
			return `${item.word}【实体】`;
		} else if (item.type === 2) {
			return `${item.word}【自定义】`;
		} else {
			return `${item.word}${item.style ? `【${item.style}】` : ''}`;
		}
	};
	// 获取图片标签列表头的下拉框的数据
	const getTagHeadSelectOptionDataSource = async (parentId, type, word) => {
		dispatch({
			type: actiontypes.setData,
			data: {
				tagHeadListLoading: true,
			},
		});
		const result = await aditMarkingTaggingRecommendTaggs({
			parentId,
			type,
		});
		if (result?.error?.code == 0) {
			result.data.forEach((t) => {
				t.type = type;
			});
			dispatch({
				type: actiontypes.setData,
				data: {
					tagHeadTags: result?.data ?? [],
					tagHeadListLoading: false,
				},
			});
		} else {
			message.error('下拉框数据获取失败');
		}
	};
	// 新增标签下拉框获取
	const getAddedTagsDataSource = async () => {
		dispatch({
			type: actiontypes.setData,
			data: {
				tagHeadListLoading: true,
			},
		});
		const result = await aditMarkingTaggingGetAddedTaggs();
		if (result?.error?.code == 0) {
			result.data.forEach((t) => {
				t.type = 2;
			});
			dispatch({
				type: actiontypes.setData,
				data: {
					tagHeadTags: result?.data ?? [],
					tagHeadListLoading: false,
				},
			});
		} else {
			message.error('下拉框数据获取失败');
		}
	};
	return useMemo(
		() => (
			<List
				bordered
				className='auditMarkingTagList'
				dataSource={state.insGroup.filter((v) => v.checked && !v.delete)}
				header={
					<div className='auditMarkingTagListHeader'>
						<div className='auditMarkingTagListTop'>
							<div
								style={{
									position: 'absolute',
									left: 30,
								}}
							>
								<Select
									mode='multiple'
									placeholder='输入并选择合适的标签，多组标签中间以空格区分'
									notFoundContent={
										state.tagsFetchLoading ? <Spin size='small' /> : null
									}
									onSearch={changeTagsSelect}
									onSelect={(v) => selectTagsSelectOption(v, true)}
									onBlur={clearFunction}
									style={{ width: '500px' }}
									className='auditMarkingTagListSelect'
									allowClear
									// autoClearSearchValue
									value={selectValue}
								>
									{state.tagList.map((item) => {
										return (
											<Select.Option
												key={item.id + " " + item.parentId}
												value={`${item.type}-${item.id}-${item.word}-${item.style}-${item.entity}-${item.parentId}`}
											>
												{renderSelectTags(item)}
											</Select.Option>
										);
									})}
								</Select>
								<div className='auditMarkingTagListTopSelectCache'>
									{state.tagsCache.map((item) => {
										return (
											<Tag
												key={item.id + " " + item.parentId} // 存在id相同的可能性，利用时间戳
												style={{
													marginTop: '5px',
													fontSize: 14,
												}}
												onClick={() => {
													state.insGroup.forEach((v) => {
														if (v.checked) {
															if (v?.newTags?.map) {
																// newTags 是否是数组
																const index = v.newTags.findIndex(
																	(t) => t.id === item.id && t.parentId === item.parentId
																); // 是否存在点击标签查看该标签是否已经北大在标签上
																if (index === -1) {
																	// 不存在，补在不存在的标签上面
																	v.newTags.push(item);
																}
															} else {
																v.newTags = [{ ...item }];
															}
														}
													});
													dispatch({
														type: actiontypes.setData,
														data: {
															insGroup: [...state.insGroup],
														},
													});
												}}
											>
												{renderSelectTags(item)}
											</Tag>
										);
									})}
								</div>
							</div>
							<h2 className='auditMarkingTagListTitle'>图片标签</h2>
							<div className='auditMarkingTaglistAddNewModal'>
								<AddTagsModal />
							</div>
						</div>
						<ul className='auditMarkingTagListTableHead'>
							<li>
								<Select
									loading={state.tagHeadListLoading}
									onDropdownVisibleChange={() =>
										getTagHeadSelectOptionDataSource(0, 1)
									}
									value='实体'
									onSelect={(v) => selectTagsSelectOption(v, false)}
								>
									{state.tagHeadTags.map((v) => (
										<Select.Option
											key={v.id + " " + v.parentId}
											value={`${v.type}-${v.id}-${v.word}-${v.style}-实体`}
										>
											{renderEntitySelectTags(v)}
										</Select.Option>
									))}
								</Select>
							</li>
							<li>
								<Select
									value='其他'
								></Select>
							</li>
							{state.tags.map((item, index) => {
								return (
									<li key={item.id}>
										<Select
											onDropdownVisibleChange={() =>
												getTagHeadSelectOptionDataSource(item.id, 0, item.word)
											}
											onSelect={(v) => selectTagsSelectOption(v, false)}
											value={item.word}
										>
											{state.tagHeadTags.map((v) => (
												<Select.Option
													key={v.id + " " + v.parentId}
													value={`${v.type}-${v.id}-${v.word}-${v.style}-${v.entity}-${v.parentId}`}
												>
													{renderSelectTags(v)}
												</Select.Option>
											))}
										</Select>
									</li>
								);
							})}
							<li>
								<Select
									value='新增标签'
									onDropdownVisibleChange={getAddedTagsDataSource}
									onSelect={(v) => selectTagsSelectOption(v, false)}
								>
									{state.tagHeadTags.map((v) => (
										<Select.Option
											key={v.id + " " + v.parentId}
											value={`${v.type}-${v.id}-${v.word}-${v.style}-${v.entity}-${v.parentId}`}
										>
											{renderSelectTags(v)}
										</Select.Option>
									))}
								</Select>
							</li>
						</ul>
					</div>
				}
				renderItem={(v) => {
					// console.log(v);
					return (
						<ul key={v} className='auditMarkingTagListTableBodyUl'>
							{/* {renderListItem(state.tags, v)} */}
							<RenderListItem tags={state.tags} item={v} />
						</ul>
					);
				}}
			/>
		),
		[
			state.tags,
			state.insGroup,
			state.tagsCache,
			state.tagList,
			state.tagsFetchLoading,
			state.tagHeadTags,
			state.tagHeadListLoading,
			selectValue
		]
	);
}

export default TagListManager;
